export default function email(value: any) {
  return !value || /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value) ? true : 'Hatalı e-posta adresi';
}
